<template>
  <SmartLinkItemComponent
    :id="model.system.id"
    :component="!model.system.workflow"
    @click="downloadFile(firstOrDefault(model.elements.file.value)?.url)"
  >
    <div class="document-item">
      <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
        <div class="title">
          <font-awesome class="icon-type" :icon="getIcon(data.type)" />
          <div class="text" v-if="data.type?.codename === 'external_link'">
            <a target="_blank" :href="data.externalLink">{{ data.title }}</a>
          </div>
          <div class="text" v-else>{{ data.title }}</div>
        </div>
      </SmartLinkStandaloneElement>

      <SmartLinkStandaloneElement :codename="typ.elements.file.codename">
        <MyLink class="icon-download" :aria-label="data.title"
          :to="data.externalLink"
          :target="'_blank'"
          v-if="data.type?.codename === 'external_link'"
        >
          <font-awesome class="icon-arrow-up-right-from-square" icon="arrow-up-right-from-square" fixed-width />
        </MyLink>
        <MyLink class="icon-download" :aria-label="data.title"
          :to="data.fileUrl"
          @click.prevent.stop="downloadFile(data.fileUrl)"
          v-else
        >
          <font-awesome class="icon-download" icon="download" fixed-width />
        </MyLink>
      </SmartLinkStandaloneElement>
    </div>
  </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import { contentTypes } from '~/models'
import { firstOrDefault } from '~/utils/first-or-default'
import { getIcon } from '~/utils/icons-util'
import { usePdfTracker } from '~/composables/usePdfTracker'

const typ = contentTypes.document
const props = defineProps<{ model: any }>()

const { downloadFile } = usePdfTracker()
const data = {
  title: props.model.elements.title.value,
  externalLink: props.model.elements.externalLink.value,
  fileUrl: firstOrDefault(props.model.elements.file.value)?.url || '',
  type: firstOrDefault(props.model.elements.type.value),
};
</script>
